<template lang="pug">
.v-calculator.calculator(v-if="data" :class="[data.type ? 'calculator--' + data.type : '']" :id="data?.id")
	.calculator__controls
		.calculator__title(v-if="data.title" v-html="data.title")
		.calculator__subtitle(v-if="data.subtitle" v-html="data.subtitle")
		.calculator__options
			.calculator__section(v-if="data.sum")
				.calculator__section-title(v-if="data.sum.title") {{data.sum.title}}
				.calculator__section-content
					v-field.calculator__range(:field="data.sum" v-model="sum" @update:model-value="handlerRange")
			.calculator__section(v-if="data.term")
				.calculator__section-title(v-if="data.term.title") {{ data.term.title }}
				.calculator__buttons(v-if="data.term.items")
					button.btn.btn--sm.calculator__button(v-for="(action, index) in data.term.items" :key="index" type="button" :class="[activeTerm === action ? 'btn--magenta' : 'btn--gray']" @click="setActiveTerm(action)")
						| {{action.term}} {{action.typeText}}
						span.calculator__button-span(v-if="action.rate") {{action.rate}} {{action.rateSymbol || '%'}}
		.calculator__additional(v-if="data.additional")
			.calculator__additional-title {{data.additional.title}}
			.calculator__checkboxes(v-if="data.additional.capitalization")
				.calculator__check
					v-field-checkbox(:field="data.additional.capitalization" :model-value="capitalization" :disabled="disableCapitalization" @update:model-value="handlerCheck")
					v-informer.calculator__check-informer(v-if="data.additional.capitalization.info" :info="data.additional.capitalization.info")
	.calculator__results
		.calculator__results-info(v-if="computedSchedule")
			.calculator__results-row
				.calculator__results-title {{ data.results.rate }}
				.calculator__results-value {{ computedSchedule.rate }} {{ activeTerm.rateSymbol || "%" }}
			.calculator__results-row
				.calculator__results-title
					| {{ data.results.sum }}
					v-informer(v-if="data.results.maxPaymentText" :info="{content: data.results.maxPaymentText}")
				.calculator__results-value(:class="{'calculator__results-value--sum': data.type === 'deposit'}")
					| {{ data.results.sumSymbol }} {{ round(computedSchedule.value) }} {{ data.sum.currency.text }}
			.calculator__results-row(v-if="data.type === 'credit'")
				.calculator__results-title {{ data.results.total }}
				.calculator__results-value {{ round(computedSchedule.total) }} {{ data.sum.currency.text }}
			.calculator__results-row(v-if="data.results?.text")
				.calculator__subtitle(v-html="data.results.text")
		.calculator__message.text-guide(v-if="data.results.message" v-html="data.results.message")
		.calculator__actions(v-if="data.actions")
			component.calculator__action.btn(v-for="action in data.actions" :is="action.link ? 'a' : 'button'" :type="action.link ? null : 'button'" :href="action.link" :class="action.className") {{action.text}}
		v-informer(v-if="data.results.informer" :info="data.results.informer")
			template(#btn)
				.calculator__results-informer
					v-svg-icon.calculator__results-informer-icon(icon="graphic-list")
					.calculator__results-informer-content
						span.calculator__results-informer-text {{ data.results.informer.text }}
</template>

<script>

import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import isScrollToSelfMixin from '../components/mixins/v-mixin-scroll-to-self.vue';

export default {

	mixins: [
		sourceMixin,
		isMobMixin,
		isScrollToSelfMixin
	],

	data() {
		return {
			data: null,
			sum: null,
			activeTerm: 0,
			capitalization: true,
			disableCapitalization: false
		}
	},

	watch: {
		activeTerm() {
			this.disableCapitalization = this.activeTerm.type === 'day' || (this.activeTerm.term < 2 && this.activeTerm.type === 'month');
			if(this.activeTerm.replaceMessage){
			  this.data.results.message = this.activeTerm.message;
			}else{
			  this.data.results.message = this.data.results.defaultMessage;
			}
		}
	},

	computed: {

		computedSchedule() {

			let total = {
				value: 0
			}

			const currentDay = this.getCurrentDay();
			const sum = this.sum;

			if(this.data.type === 'deposit') {
				total.rate = this.activeTerm.rate
				const rate = this.activeTerm.rate
				let term = this.activeTerm.type === 'year' ? this.activeTerm.term * 12 : this.activeTerm.term;


				if(this.activeTerm.type === "day"){
					total.value = sum * rate * term / 365 / 100
					return total;
				}

				if(this.capitalization) {
					for(let i = 1; i < +term + 1; i++) {
						const numberOfDaysInMonth = this.getDaysInCurrentMonth(i);
						total.value += (sum + total.value) * rate * numberOfDaysInMonth / 365 / 100
					}
					return total;
				}

				const lastDayOfCurrentMonth = this.getDaysInCurrentMonth(1)

				const remainingNumberOfDaysInCurrentMonth = lastDayOfCurrentMonth - currentDay

				let quantityDays = 0

				for(let i = 1; i < term; i++) {
					const numberOfDaysInMonth = this.getDaysInNextMonth(i);
					quantityDays += numberOfDaysInMonth
				}

				total.value = sum * rate * (remainingNumberOfDaysInCurrentMonth + quantityDays + (currentDay - 1)) / 365 / 100

				return total
			}

			if(this.data.type === 'credit') {
				total.rate = this.activeTerm.rate
				total.total = 0

				const months = this.activeTerm.type === 'year' ? this.activeTerm.term * 12 : this.activeTerm.term;
				const rate = this.activeTerm.rate / 100;
				const isLeap = year => new Date(year, 1, 29).getMonth() === 1 ? 366 : 365;

				let currentYear = new Date().getFullYear();
				let currentMonth = new Date().getMonth();
				let SUM = 0;

				let localYear = currentYear
				for (let i = 1; i <= months; i++) {
					// console.log(`${SUM} += ((${sum} / ${months}) + ${(sum - (sum / months * (i - 1)))} * ${rate} * ${this.daysInMonth(localYear, currentMonth)} / ${isLeap(localYear)})`)
					SUM += ((sum / months) + (sum - (sum / months * (i - 1))) * rate * this.daysInMonth(localYear, currentMonth) / isLeap(localYear));
					if (currentMonth === 11) {
						currentMonth = 0
						localYear++
					} else {
						currentMonth++
					}
				}

				total.value = this.data.annuityPayment
					? this.sum / (( 1 - (1 + rate / 12) ** (-(months))) / (rate / 12))
					: (this.sum / months) + (this.sum * rate * this.daysInMonth(currentYear, currentMonth) / isLeap(currentYear));

				total.total = this.data.annuityPayment
					? total.value * months
					: +SUM.toFixed(2)

				return total
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.data.results.defaultMessage = data.results.message;
			if(this.data?.term?.items[0]){
			  let counterChecked = 0;
			  for(let key in this.data?.term?.items)
			  {
			    let item = this.data?.term?.items[key];
			    if(item['checked']){
				  this.activeTerm = item;
				  counterChecked++;
				  break;
				}
			  }
			  if(counterChecked == 0){
				this.activeTerm = this.data?.term?.items[0];
			  }
			  if(this.activeTerm.replaceMessage){
				this.data.results.message = this.activeTerm.message;
			  }
			}
			this.sum = this.data?.sum?.value;
			this.capitalization = data?.additional?.capitalization?.active
		},

		handlerRange(value) {
			 this.sum = value
		},

		handlerCheck(value) {
			this.capitalization = value
		},

		setActiveTerm(value) {
			this.activeTerm = value;
		},

		getCurrentDay() {
			return new Date().getDate()
		},

		getDaysInCurrentMonth(value) {
			const currentDate = new Date();
			return new Date(currentDate.getFullYear(), currentDate.getMonth() + value, 0).getDate();
		},

		getDaysInNextMonth(value) {
			const currentDate = new Date();
			return new Date(currentDate.getFullYear(), currentDate.getMonth() + value + 1, 0).getDate();
		},

		daysInMonth(year, month) {
			return 33 - new Date(new Date(year, month, 1).getFullYear(), new Date(year, month, 1).getMonth(), 33).getDate();
		},

		round(val) {
			try {
				return (Math.round(val * 100) / 100).toFixed(2)
			} catch (e) {
				console.warn(e);
				return val
			}
		}
	}
}

</script>
